export default "__VITE_ASSET__7lWYPOaG__"